import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { ApiService, Estimate } from '@mmx/shared'
import { get } from 'lodash'
import { BehaviorSubject, catchError, filter, finalize, of, Subject, switchMap, takeUntil, tap } from 'rxjs'

@Component({
  selector: 'mmx-model-claim-search',
  templateUrl: './model-claim-search.component.html',
  standalone: false,
})
export class ModelClaimSearchComponent implements OnInit, OnDestroy {
  @Input() facilityId: string
  @Input() serviceType: Estimate.PATIENT_TYPE
  @Output() modelClaim = new EventEmitter()

  loading$ = new BehaviorSubject(false)
  search$ = new BehaviorSubject<string>(null)
  errorMessages$ = new BehaviorSubject<string[]>([])

  private onDestroy$ = new Subject<void>()

  constructor(
    private restService: ApiService,
    private fb: FormBuilder,
  ) { }

  claimForm = this.fb.group({
    search: this.fb.control<string>(null),
  })

  modelClaimSearch$ = this.search$.pipe(
    takeUntil(this.onDestroy$),
    filter(Boolean),
    // distinctUntilChanged(),
    switchMap(query => this.restService.getModelClaim({
      facilityId: this.facilityId,
      serviceType: this.serviceType,
      query,
    }).pipe(
      finalize(() => this.loading$.next(false)),
      catchError((err: any) => {
        this.errorMessages$.next(get(err, 'error.error.message', ''))
        this.claimForm.controls.search.setErrors({ invalid: true })
        return of(null)
      }),
    )),
    tap(claim => this.modelClaim.next(claim)),
  )

  ngOnInit(): void {
    this.modelClaimSearch$.subscribe()
  }

  ngOnDestroy(): void {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  onSubmit(): void {
    this.loading$.next(true)
    this.search$.next(this.claimForm.value.search)
  }
}
